import {useParams} from "react-router-dom";
import PageContainer from "../../../components/container/PageContainer";
import React, {useEffect, useState} from "react";
import Tabs from "../../../components/Tabs";
import ProcessosResumo from "../Resumo";
import ProcessosFichaCadastral from "../FichaCadastral";
import ProcessosLinhaTempo from "../LinhaTempo";
import Alert from "../../../helpers/Alert";
import processosApi from "../../../services/processosApi";
import situacaoProcessoApi from "../../../services/situacaoProcessoApi";
import useModal from '../../../hooks/useModal';
import cronogramaApi from "../../../services/cronogramaApi";
import ClienteFormData from "../ClienteFormData";
import Storage from "../../../helpers/Storage";

export default function ViewProcessos() {
    const params = useParams();
    const id = params.id;
    const userData: any = Storage.getUserData();
    const [stateProcesso, setStateProcesso] = useState<any>({});
    const [stateSituacao, setStateSituacao] = useState<any>({});
    const [loading, setLoading] = useState(true);
    const [tabData, setTabData] = useState<any>([]);

    const [atualizar, setAtualizar] = useState(false);



    async function getData(){
        Alert.await(`Carregando dados...`);
        setLoading(true);
        if (id){
            const [situacaoProcesso, processo, cronogramaProcessoData] = await  Promise.all([situacaoProcessoApi.listAll(), processosApi.one(id), cronogramaApi.cronogramasProcesso(id)]);
            const processoData = !processo.isError ? processo?.data?.data : null;
            if (!processoData) {
                setStateProcesso({});
                setTabData([]);
                setLoading(false);
                Alert.error('Processo não encontrado.');
                return;
            }

            const cronogramaProcesso = cronogramaProcessoData.isError ? [] : (cronogramaProcessoData.data?.data || []);

            let arraySituacao: any[] = [];
            if (!situacaoProcesso.isError){
                // @ts-ignore
                arraySituacao = situacaoProcesso.data.data.map((situacao, index) => {
                    const cronogramaFind = cronogramaProcesso.find((cronograma: any) => cronograma.situacao_id === situacao.id);

                    if (cronogramaFind){
                        return {
                            id: situacao.id,
                            nome: situacao.nome,
                            data_finalizacao: cronogramaFind.data_prazo_finalizacao,
                            status: cronogramaFind.data_finalizacao ? 'concluido' : 'andamento', //andamento, concluido, aFazer
                        }
                    }else{
                        return {
                            id: situacao.id,
                            nome: situacao.nome,
                            status: 'aFazer', //andamento, concluido, aFazer
                        }
                    }
                });
                const indexs = arraySituacao.reduce(function(a: any, e: any, i: any) {
                    if (e.status === 'andamento'){
                        a.push(i);
                    }
                    return a;
                }, []);
                indexs.map((ind: any, key: number) => {
                    if (key){
                        arraySituacao[ind]['status'] = 'aFazer';

                    }
                })

            }
            setStateProcesso(processoData);
            const arrayProcessos = {
                title: 'Resumo',
                component: <ProcessosResumo
                    processoId={processoData.id}
                    resumoData={processoData}
                    setAtualizar={setAtualizar}
                />
            };
            let dataFinal: any[] = []

            if (userData.usuario.tipo_id !== 3){
                dataFinal = [
                    arrayProcessos,
                    {
                        title: 'Formulario',
                        component: <ClienteFormData
                            processoId={processoData.id}
                            tipoVistoId={processoData.tipo_visto_id}
                        />
                    },
                    {
                        title: 'Ficha Cadastral',
                        component: <ProcessosFichaCadastral processo={processoData}/>
                    },
                    {
                        title: 'Linha do tempo',
                        component: <ProcessosLinhaTempo
                            situacoes={arraySituacao}
                            processoId={processoData.id}
                            setAtualizar={setAtualizar}
                            cronogramaAtual={processoData.ultimo_cronograma ? processoData.ultimo_cronograma : processoData.ultimo_cronograma_concluido}
                            quantidadeProcessoResponsavel={processoData.processos_membros_resumido}
                            cronogramaProcesso={cronogramaProcesso}
                        />
                    },

                ]
            }else{
                dataFinal = [
                    arrayProcessos,
                    {
                        title: 'Linha do tempo',
                        component: <ProcessosLinhaTempo
                            situacoes={arraySituacao}
                            processoId={processoData.id}
                            setAtualizar={setAtualizar}
                            cronogramaAtual={processoData.ultimo_cronograma ? processoData.ultimo_cronograma : processoData.ultimo_cronograma_concluido}
                            quantidadeProcessoResponsavel={processoData.processos_membros_resumido}
                            cronogramaProcesso={cronogramaProcesso}
                        />
                    }
                ]
            }


            //console.log(dataFinal, dataFinal.reverse());
            setTabData(dataFinal.reverse());
        }
        setLoading(false);
        Alert.close();
    }



    useEffect(() => {
        setAtualizar(false);
        getData()
    }, [atualizar]);

    useEffect(() => {
        getData()
    }, [])
    if (loading) return (<></>);

    return(
        <>
            <PageContainer pageTitle={'Processos'} pageTitleSecond={`${stateProcesso.cliente?.nome} ${stateProcesso.cliente?.sobrenome}`}>
                {
                    loading ? '' : <Tabs tabData={tabData}/>
                }
            </PageContainer>

        </>
    )
}